import Cookies from "js-cookie";
import EncryptionHelper from "./encryptionHelper";

const CookieHelper = {

  get: (key: string) => {
    const dataEncrypted: string = Cookies.get(key) ?? '';
    return dataEncrypted !== 'null' ? EncryptionHelper.decrypt(dataEncrypted) : '';
  },

  set: (key: string, data: string, ex: number): void => {
    const dataEncrypted: string = EncryptionHelper.encrypt(data) as unknown as string;
    Cookies.set(key, dataEncrypted, {expires: ex});
  },

  remove: (key: string): void => {
    Cookies.remove(key);
  }

}

export default CookieHelper;


